import { PanelbarStructure } from "../isPanelbarDetails.js";
import { Helper } from "../../util/helper.js";
import React from "react";
export default class ContactPersonDetails extends React.Component<any, any> {
    private renderTeamsButton = (icon: string, link: string) => {
        return (
            <span onClick={this.createOnClickEvent(link)} >
                <i className={"fa-solid fa-" + icon} data-style="solid"></i>
                <i className={"fa-regular fa-" + icon} data-style="regular"></i>
                <div style={{ backgroundColor: "#464eb8", color: "white", borderRadius: "25%", height: "15px", width: "15px", position: "relative", top: "-12px", left: "17px" }}>
                    <i className="fa-regular fa-t" aria-hidden="true" style={{ fontSize: "10px", position: "relative", top: "-8px", left: "3.5px" }}></i>
                </div>
            </span>);
    }

    private createOnClickEvent = (link: string) => {
        return () => {
            window.open(link)
        };
    }

    render() {
        const data = this.props.data;
        const dataAnrede = Helper.hasValue(data.Anrede) ? data.Anrede.toString() + " " : "";
        const dataVorname = Helper.hasValue(data.Vorname) ? data.Vorname + " " : "";
        const dataAnsprechpatner = Helper.hasValue(data.Ansprechpartner) ? data.Ansprechpartner : "";
        return (
            <PanelbarStructure label={dataAnrede + dataVorname + dataAnsprechpatner}
                keyPropValue={data.Pos} iconName={"id-badge"} url={"Contact/Edit?id=" + encodeURIComponent(data.Pos)}>
                <style>
                    {`.external__button {width: min-content;margin-right: 15px;}`}
                    {`.external__button i{font-size: x-large;}`}
                    {`.external__button i[data-style="solid"]{display: none}`}
                    {`.external__button i[data-style="regular"]{display: inline}`}
                    {`.external__button:hover i[data-style="solid"]{display: inline}`}
                    {`.external__button:hover i[data-style="regular"]{display: none}`}
                </style>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>
                                    <i className="fa-regular fa-house" style={{ marginRight: "15px" }} ></i>
                                    {data.AdrName + ", " + data.Ort}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>
                                    <i className="fa-regular fa-envelope" style={{ marginRight: "15px" }} ></i>
                                    {data.Email1}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>
                                    <i className="fa-regular fa-phone" style={{ marginRight: "15px" }} ></i>
                                    {data.Telefon1}
                                </span>
                            </td>
                        </tr>
                        {Helper.isNullOrEmpty(data.Handy1) ? null : <tr>
                            <td>
                                <span>
                                    <i className="fa-regular fa-mobile-notch" style={{ marginRight: "15px", marginLeft: "4px" }} ></i>
                                    {data.Handy1}
                                </span>
                            </td>
                        </tr>}
                        
                        <tr>
                            <td>
                                <div style={{ display: "flex", marginTop: "5px", cursor: "pointer" }} >
                                    {
                                        Helper.isNullOrEmpty(data.Email1) ? null : (
                                            <div className="external__button" onClick={this.createOnClickEvent(`mailto:${data.Email1}`)} >
                                                <i className="fa-solid fa-envelope" data-style="solid"></i>
                                                <i className="fa-regular fa-envelope" data-style="regular"></i>
                                            </div>
                                        )
                                    }
                                    {
                                        Helper.isNullOrEmpty(data.Telefon1) ? null : (
                                            <div className="external__button" onClick={this.createOnClickEvent(`tel:${data.Telefon1}`)}>
                                                <i className="fa-solid fa-phone" data-style="solid"></i>
                                                <i className="fa-regular fa-phone" data-style="regular"></i>
                                            </div>
                                        )
                                    }
                                    {
                                        Helper.isNullOrEmpty(data.TeamsMail) ? null : (
                                            <>

                                                <div className="external__button">
                                                    {this.renderTeamsButton("comments", `https://teams.microsoft.com/l/chat/0/0?users=${data.TeamsMail}`)}
                                                </div>
                                                <div className="external__button">
                                                    {this.renderTeamsButton("headset", `https://teams.microsoft.com/l/call/0/0?users=${data.TeamsMail}`)}
                                                </div>
                                            </>
                                        )
                                    }


                                </div>
                            </td>
                        </tr>






                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}